'use client';
import { useState } from 'react';
import NavHeader from 'de-sxm-reactlib-2/components/organisms/NavHeader/NavHeader';
import { NavHeaderProps } from 'de-sxm-reactlib-2/components/organisms/NavHeader/NavHeader.type';
import NavSearch from './NavSearch';
import Script from "next/script";

interface ClientNavHeaderProps extends NavHeaderProps {
    domain: string;
    algolia: {
        appID: string;
        apiKey: string;
        indexName: string;
    };
}

export default function ClientNavigationHeader({
    logo,
    logoUrl,
    navLeftItems,
    helpCenterItem,
    theme,
    appdownloadItem,
    search,
    account,
    avoidNavScroll,
    supportTitle,
    navRightCtas,
    navTheme,
    searchSuggestions,
    searchSuggestionsLabel,
    searchQuickLinks,
    announcementBanners,
    headerId,
    quickLinksHeader,
    overlap = true,
    domain = 'https://www.siriusxm.com',
    algolia,
    preventScrollUp,
}: ClientNavHeaderProps) {
    const [navSearchOpen, setNavSearchOpen] = useState(false);

    const searchBar = (
        <NavSearch
            open={navSearchOpen}
            searchTerm=""
            minSearchLength={3}
            userTypingDelay={250}
            searchSuggestions={searchSuggestions}
            searchSuggestionsLabel={searchSuggestionsLabel}
            searchQuickLinks={searchQuickLinks}
            onCancelClick={() => setNavSearchOpen(false)}
            quickLinksHeader={quickLinksHeader}
            domain={domain}
            algolia={algolia}
        />
    );

    return (
        <><Script src="/ns/cms/static/global/widget/ui-nav/sxm-ui-navigation.js" async strategy='lazyOnload'/>
        <NavHeader
            logo={logo}
            logoUrl={logoUrl}
            navLeftItems={navLeftItems}
            helpCenterItem={helpCenterItem}
            theme={theme}
            appdownloadItem={appdownloadItem}
            searchBar={searchBar}
            searchOpen={navSearchOpen}
            onSearchClose={() => setNavSearchOpen(false)}
            onSearchOpen={() => setNavSearchOpen(true)}
            search={search}
            account={account}
            avoidNavScroll={avoidNavScroll}
            supportTitle={supportTitle}
            navRightCtas={navRightCtas}
            navTheme={navTheme}
            announcementBanners={announcementBanners}
            headerId={headerId}
            overlap={overlap}
            preventScrollUp={preventScrollUp}
        /></>
    );
}
